module.exports = __webpack_public_path__ + "img/LOGIC-IMMO_RVB.svg";